jQuery(function ($) {
    $('.tablepress').wrap('<div class="tablepress-wrapper"></div>');
});